import type { GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { NewsDetails } from "views";
import { normalizeConference } from "utils/normalizer";
import { TAG_TREES } from "utils/constants";
import { is404 } from "utils/newFunction";
import { Formatter } from "utils/formatter";

function NewsDetailsPage({ data }) {
  return (
    <NewsDetails
      data={data}
      type="conferences"
      suggestedItemsLabel={{
        fa: "مطالب پیشنهادی",
        en: "Suggested for you",
      }}
    />
  );
}

const generateBreadcrumb = (item, locale) =>
  locale === "fa"
    ? [
        { title: "کنفرانس و گردهمایی‌ها", link: "/conferences" },
        { title: item?.title?.value || "جزییات همایش" },
      ]
    : [
        { title: "Conferences and Gatherings", link: "/conferences" },
        { title: item?.title?.value || "Conference Details" },
      ];

export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const apiService = new ApiService(locale);
  try {
    const entityId = params?.entityId;
    const slug = params?.slug?.[0];

    if (Number.isNaN(+entityId)) {
      return {
        notFound: true,
      };
    }

    const requests = [
      apiService.getConferenceList({ size: 3 }), // 0
    ];
    requests.push(apiService.getConferenceById(entityId, { formatter: false })); // 1

    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}
    if (is404(response?.[1])) {
      return {
        notFound: true,
      };
    }
    const target = Formatter.formatData({ data: response?.[1] })?.[0];

    if (
      !target?.tagTrees?.find(
        (item) =>
          item?.name === TAG_TREES[locale?.toUpperCase() || "FA"]?.CONFERENCES
      )
    ) {
      return {
        notFound: true,
      };
    }
    const normalizedConference = normalizeConference(target);

    if (normalizedConference.slug && normalizedConference.slug !== slug) {
      return {
        redirect: {
          permanent: true,
          destination: `${
            locale === "en" ? "/en" : ""
          }/conferences/${entityId}/${encodeURIComponent(
            normalizedConference.slug
          )}`,
        },
      };
    }

    return {
      props: {
        data: {
          latestNews: response?.[0] || [],
          news: target || null,
          changeLanguageLink: target?.changeLanguageLink?.value,
          canonical: !target?.changeLanguageLink?.value,
          breadcrumb:
            target?.breadcrumb?.length > 0
              ? target?.breadcrumb
              : generateBreadcrumb(target, locale),
          shouldHideVideosButtonLink:
            normalizedConference?.videos?.length === 0,
          videosButton: {
            fa: {
              title: "مشاهده ویدیو‌ها",
              link: normalizedConference?.videos?.[0]?.link || "",
            },
            en: {
              title: "See Videos",
              link: normalizedConference?.videos?.[0]?.link || "",
            },
          },
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default NewsDetailsPage;
